function SvgShape({ viewBox, children, fill, stroke, strokeWidth }) {
  return (
    <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <svg viewBox={viewBox} style={{ width: '100%', height: '100%' }} fill={fill} stroke={stroke || 'none'} strokeWidth={strokeWidth}>
        {children}
      </svg>
    </div>
  );
}

export default function ShapeLayerRenderer({ layer }) {
  const data = layer.data;
  const f = data.fill;
  const s = data.stroke || 'none';
  const sw = data.strokeWidth || 0;

  switch (data.shape) {
    case 'circle':
      return <div style={{ width: '100%', height: '100%', background: f, border: data.stroke ? `${sw}px solid ${s}` : 'none', borderRadius: '50%' }} />;

    case 'rounded-rectangle':
      return <div style={{ width: '100%', height: '100%', background: f, border: data.stroke ? `${sw}px solid ${s}` : 'none', borderRadius: data.borderRadius ?? 24 }} />;

    case 'ellipse':
      return <div style={{ width: '100%', height: '100%', background: f, border: data.stroke ? `${sw}px solid ${s}` : 'none', borderRadius: '50%' }} />;

    case 'line':
      return <div style={{ width: '100%', height: '100%', background: f, borderRadius: 2 }} />;

    case 'line-diagonal':
      return (
        <SvgShape viewBox="0 0 100 100" fill="none" stroke={f} strokeWidth={4}>
          <line x1="5" y1="95" x2="95" y2="5" strokeLinecap="round" />
        </SvgShape>
      );

    case 'triangle':
      return (
        <SvgShape viewBox="0 0 100 86" fill={f} stroke={s} strokeWidth={sw}>
          <polygon points="50,0 100,86 0,86" />
        </SvgShape>
      );

    case 'triangle-down':
      return (
        <SvgShape viewBox="0 0 100 86" fill={f} stroke={s} strokeWidth={sw}>
          <polygon points="0,0 100,0 50,86" />
        </SvgShape>
      );

    case 'diamond':
      return (
        <SvgShape viewBox="0 0 100 100" fill={f} stroke={s} strokeWidth={sw}>
          <polygon points="50,5 95,50 50,95 5,50" />
        </SvgShape>
      );

    case 'star':
      return (
        <SvgShape viewBox="0 0 100 100" fill={f} stroke={s} strokeWidth={sw}>
          <polygon points="50,5 61,35 95,35 68,57 79,91 50,70 21,91 32,57 5,35 39,35" />
        </SvgShape>
      );

    case 'star6':
      return (
        <SvgShape viewBox="0 0 100 100" fill={f} stroke={s} strokeWidth={sw}>
          <polygon points="50,5 59,35 88,20 73,47 95,65 63,65 50,95 37,65 5,65 27,47 12,20 41,35" />
        </SvgShape>
      );

    case 'heart':
      return (
        <SvgShape viewBox="0 0 100 100" fill={f} stroke={s} strokeWidth={sw}>
          <path d="M50,88 C50,88 12,60 12,35 C12,22 22,15 35,15 C42,15 48,19 50,23 C52,19 58,15 65,15 C78,15 88,22 88,35 C88,60 50,88 50,88Z" />
        </SvgShape>
      );

    case 'pentagon':
      return (
        <SvgShape viewBox="0 0 100 100" fill={f} stroke={s} strokeWidth={sw}>
          <polygon points="50,5 97,38 79,95 21,95 3,38" />
        </SvgShape>
      );

    case 'hexagon':
      return (
        <SvgShape viewBox="0 0 100 100" fill={f} stroke={s} strokeWidth={sw}>
          <polygon points="50,5 93,27 93,73 50,95 7,73 7,27" />
        </SvgShape>
      );

    case 'octagon':
      return (
        <SvgShape viewBox="0 0 100 100" fill={f} stroke={s} strokeWidth={sw}>
          <polygon points="30,5 70,5 95,30 95,70 70,95 30,95 5,70 5,30" />
        </SvgShape>
      );

    case 'arrow-right':
      return (
        <SvgShape viewBox="0 0 100 60" fill={f} stroke={s} strokeWidth={sw}>
          <polygon points="0,15 65,15 65,0 100,30 65,60 65,45 0,45" />
        </SvgShape>
      );

    case 'arrow-left':
      return (
        <SvgShape viewBox="0 0 100 60" fill={f} stroke={s} strokeWidth={sw}>
          <polygon points="100,15 35,15 35,0 0,30 35,60 35,45 100,45" />
        </SvgShape>
      );

    case 'cross':
      return (
        <SvgShape viewBox="0 0 100 100" fill={f} stroke={s} strokeWidth={sw}>
          <polygon points="35,0 65,0 65,35 100,35 100,65 65,65 65,100 35,100 35,65 0,65 0,35 35,35" />
        </SvgShape>
      );

    case 'parallelogram':
      return (
        <SvgShape viewBox="0 0 100 60" fill={f} stroke={s} strokeWidth={sw}>
          <polygon points="20,0 100,0 80,60 0,60" />
        </SvgShape>
      );

    case 'trapezoid':
      return (
        <SvgShape viewBox="0 0 100 60" fill={f} stroke={s} strokeWidth={sw}>
          <polygon points="20,0 80,0 100,60 0,60" />
        </SvgShape>
      );

    // ── Social Media Logos ───────────────────────────────────
    case 'instagram':
      return (
        <SvgShape viewBox="0 0 100 100" fill="none" stroke={f} strokeWidth={0}>
          <rect x="15" y="15" width="70" height="70" rx="20" fill="none" stroke={f} strokeWidth="7"/>
          <circle cx="50" cy="50" r="18" fill="none" stroke={f} strokeWidth="7"/>
          <circle cx="73" cy="27" r="5" fill={f}/>
        </SvgShape>
      );

    case 'facebook':
      return (
        <SvgShape viewBox="0 0 100 100" fill={f} stroke={s} strokeWidth={sw}>
          <path d="M80,5H20C11.7,5,5,11.7,5,20v60c0,8.3,6.7,15,15,15h25V62H35V48h10V38c0-11,7.2-17,16.5-17c4.7,0,9.5,0.8,9.5,0.8v10.7H65.7c-5.3,0-7,3.3-7,6.7V48h12l-2,14H58.7v33H80c8.3,0,15-6.7,15-15V20C95,11.7,88.3,5,80,5z" />
        </SvgShape>
      );

    case 'twitter-x':
      return (
        <SvgShape viewBox="0 0 100 100" fill={f} stroke={s} strokeWidth={sw}>
          <path d="M87,10L53,52l36,38H78L51,59L29,90H5l36-42L7,10h12l24,27L64,10H87zM75,83L22,17h6l53,66H75z" />
        </SvgShape>
      );

    case 'youtube':
      return (
        <SvgShape viewBox="0 0 100 100" fill={f} stroke={s} strokeWidth={sw}>
          <rect x="5" y="18" width="90" height="64" rx="16" />
          <polygon points="40,35 40,65 68,50" fill="#fff"/>
        </SvgShape>
      );

    case 'tiktok':
      return (
        <SvgShape viewBox="0 0 100 100" fill={f} stroke={s} strokeWidth={sw}>
          <path d="M72,5v20c10,2,18-3,22-8v18c-6,3-14,2-22-3v30c0,18-15,33-33,33S6,80,6,62s15-33,33-33v18c-8,0-15,7-15,15s7,15,15,15s15-7,15-15V5H72z" />
        </SvgShape>
      );

    case 'linkedin':
      return (
        <SvgShape viewBox="0 0 100 100" fill={f} stroke={s} strokeWidth={sw}>
          <rect x="5" y="5" width="90" height="90" rx="15" />
          <rect x="18" y="42" width="14" height="40" fill="#fff"/>
          <circle cx="25" cy="28" r="9" fill="#fff"/>
          <path d="M44,42h13v5.5c2-3.5,7-6.5,14-6.5c13,0,16,8,16,20v21H74V64c0-5-1-10-8-10c-7,0-9,5-9,10v18H44V42z" fill="#fff"/>
        </SvgShape>
      );

    case 'whatsapp':
      return (
        <SvgShape viewBox="0 0 100 100" fill={f} stroke={s} strokeWidth={sw}>
          <path d="M50,5C25,5,5,25,5,50c0,8,2.2,15.5,5.8,22L5,95l23.5-5.5C35,92.5,42.3,95,50,95c25,0,45-20,45-45S75,5,50,5zM50,85c-7,0-13.5-2-19-5.5l-13,3.5l3.5-12.5C18,65,16,57.7,16,50c0-18.8,15.2-34,34-34s34,15.2,34,34S68.8,85,50,85zM70,58c-1.5-0.8-8-4-9.3-4.5c-1.3-0.5-2.2-0.8-3,0.8c-1,1.5-3.5,4.5-4.3,5.3c-0.8,1-1.5,1-3,0.3c-1.5-0.8-6.3-2.3-12-7.5c-4.5-4-7.5-9-8.3-10.5c-0.8-1.5,0-2.3,0.7-3c0.7-0.7,1.5-1.8,2.3-2.7c0.8-1,1-1.5,1.5-2.5c0.5-1,0.3-1.8,0-2.7c-0.3-0.8-3-7.3-4.2-10c-1-2.7-2.2-2.3-3-2.3H25c-1,0-2.7,0.3-4,1.8c-1.3,1.5-5,5-5,12s5.3,14,6,15c0.8,1,10.5,16,25.5,22.5c3.5,1.5,6.3,2.5,8.5,3.2c3.5,1,6.7,0.8,9.2,0.5c2.8-0.5,8-3.3,9.2-6.5c1-3.2,1-6,0.7-6.5C71.7,59,70.7,58.7,70,58z" />
        </SvgShape>
      );

    case 'pinterest':
      return (
        <SvgShape viewBox="0 0 100 100" fill={f} stroke={s} strokeWidth={sw}>
          <path d="M50,5C25,5,5,25,5,50c0,19,11.5,35.2,28,42c-0.5-3.5-0.8-8.8,0-12.5c1-4,6-25.5,6-25.5s-1.5-3-1.5-7.5c0-7,4-12.2,9-12.2c4.3,0,6.3,3.2,6.3,7c0,4.3-2.7,10.7-4.2,16.5c-1.2,5,2.5,9.2,7.5,9.2c9,0,16-9.5,16-23c0-12-8.7-20.5-21-20.5c-14.3,0-22.7,10.7-22.7,21.8c0,4.3,1.7,9,3.7,11.5c0.5,0.5,0.5,1,0.3,1.5c-0.3,1.5-1.2,5-1.3,5.5c-0.2,0.8-0.8,1-1.5,0.5C23,60,18.7,51.3,18.7,43c0-16,11.5-30.5,33.3-30.5c17.5,0,31,12.5,31,29C83,60,72,74,57,74c-5,0-9.7-2.5-11.3-5.5l-3.2,12c-1.2,4.5-4.2,10-6.3,13.3C40,95.2,45,96,50,96c25,0,45-20,45-45C95,26,75,5,50,5z" />
        </SvgShape>
      );

    // ── Decorative & Design ──────────────────────────────────
    case 'badge':
      return (
        <SvgShape viewBox="0 0 100 100" fill={f} stroke={s} strokeWidth={sw}>
          <circle cx="50" cy="45" r="35" />
          <polygon points="32,72 50,95 68,72" />
        </SvgShape>
      );

    case 'ribbon':
      return (
        <SvgShape viewBox="0 0 100 80" fill={f} stroke={s} strokeWidth={sw}>
          <path d="M10,20h80v50c0,0-20-10-40,0s-40,0-40,0V20z M10,20l15,10L10,40 M90,20l-15,10L90,40" />
        </SvgShape>
      );

    case 'burst':
      return (
        <SvgShape viewBox="0 0 100 100" fill={f} stroke={s} strokeWidth={sw}>
          <polygon points="50,2 58,30 88,12 70,38 98,50 70,62 88,88 58,70 50,98 42,70 12,88 30,62 2,50 30,38 12,12 42,30" />
        </SvgShape>
      );

    case 'chat-bubble':
      return (
        <SvgShape viewBox="0 0 100 90" fill={f} stroke={s} strokeWidth={sw}>
          <path d="M8,8 h84 a8,8 0 0 1 8,8 v42 a8,8 0 0 1 -8,8 H35 l-15,20 v-20 H8 a8,8 0 0 1 -8,-8 V16 a8,8 0 0 1 8,-8z" />
        </SvgShape>
      );

    case 'speech-bubble':
      return (
        <SvgShape viewBox="0 0 100 100" fill={f} stroke={s} strokeWidth={sw}>
          <path d="M50,5C24,5,5,20,5,40c0,12,8,22,20,28l-5,22l20-15c3,0.5,6.5,0.8,10,0.8c26,0,45-15,45-35S76,5,50,5z" />
        </SvgShape>
      );

    case 'pill':
      return <div style={{ width: '100%', height: '100%', background: f, border: data.stroke ? `${sw}px solid ${s}` : 'none', borderRadius: '999px' }} />;

    case 'tag':
      return (
        <SvgShape viewBox="0 0 100 100" fill={f} stroke={s} strokeWidth={sw}>
          <path d="M10,10h45l35,40l-35,40H10V10z M30,40a7,7,0,1,0,0,0.1" />
        </SvgShape>
      );

    // ── Arrows & Pointers ────────────────────────────────────
    case 'arrow-up':
      return (
        <SvgShape viewBox="0 0 100 100" fill={f} stroke={s} strokeWidth={sw}>
          <polygon points="50,5 90,55 70,55 70,95 30,95 30,55 10,55" />
        </SvgShape>
      );

    case 'arrow-down':
      return (
        <SvgShape viewBox="0 0 100 100" fill={f} stroke={s} strokeWidth={sw}>
          <polygon points="50,95 90,45 70,45 70,5 30,5 30,45 10,45" />
        </SvgShape>
      );

    case 'chevron-right':
      return (
        <SvgShape viewBox="0 0 100 100" fill="none" stroke={f} strokeWidth={0}>
          <polyline points="30,10 70,50 30,90" fill="none" stroke={f} strokeWidth="12" strokeLinecap="round" strokeLinejoin="round" />
        </SvgShape>
      );

    case 'chevron-left':
      return (
        <SvgShape viewBox="0 0 100 100" fill="none" stroke={f} strokeWidth={0}>
          <polyline points="70,10 30,50 70,90" fill="none" stroke={f} strokeWidth="12" strokeLinecap="round" strokeLinejoin="round" />
        </SvgShape>
      );

    // ── Utility ──────────────────────────────────────────────
    case 'ring':
      return (
        <SvgShape viewBox="0 0 100 100" fill="none" stroke={f} strokeWidth={0}>
          <circle cx="50" cy="50" r="38" fill="none" stroke={f} strokeWidth="10" />
        </SvgShape>
      );

    case 'half-circle':
      return (
        <SvgShape viewBox="0 0 100 55" fill={f} stroke={s} strokeWidth={sw}>
          <path d="M5,50a45,45,0,0,1,90,0z" />
        </SvgShape>
      );

    case 'quarter-circle':
      return (
        <SvgShape viewBox="0 0 100 100" fill={f} stroke={s} strokeWidth={sw}>
          <path d="M5,95a90,90,0,0,1,90-90v90z" />
        </SvgShape>
      );

    case 'wave':
      return (
        <SvgShape viewBox="0 0 100 60" fill="none" stroke={f} strokeWidth={0}>
          <path d="M0,30 C15,5 35,55 50,30 C65,5 85,55 100,30" fill="none" stroke={f} strokeWidth="8" strokeLinecap="round" />
        </SvgShape>
      );

    case 'zigzag':
      return (
        <SvgShape viewBox="0 0 100 60" fill="none" stroke={f} strokeWidth={0}>
          <polyline points="5,50 20,10 35,50 50,10 65,50 80,10 95,50" fill="none" stroke={f} strokeWidth="8" strokeLinecap="round" strokeLinejoin="round" />
        </SvgShape>
      );

    // ── Stickers & Symbols ───────────────────────────────────
    case 'flame':
      return (
        <SvgShape viewBox="0 0 100 100" fill={f} stroke={s} strokeWidth={sw}>
          <path d="M50,5 C50,5 75,30 75,55 C75,72 64,85 50,90 C36,85 25,72 25,55 C25,45 35,35 40,30 C40,30 38,50 50,55 C50,55 50,30 50,5Z" />
        </SvgShape>
      );

    case 'lightning':
      return (
        <SvgShape viewBox="0 0 100 100" fill={f} stroke={s} strokeWidth={sw}>
          <polygon points="55,5 25,50 45,50 40,95 75,42 52,42" />
        </SvgShape>
      );

    case 'location-pin':
      return (
        <SvgShape viewBox="0 0 100 100" fill={f} stroke={s} strokeWidth={sw}>
          <path d="M50,90 C50,90 18,55 18,35 C18,17 32,5 50,5 S82,17 82,35 C82,55 50,90 50,90Z M50,24 a12,12 0 1,0 0,24 a12,12 0 1,0 0,-24Z" fillRule="evenodd" />
        </SvgShape>
      );

    case 'crown':
      return (
        <SvgShape viewBox="0 0 100 80" fill={f} stroke={s} strokeWidth={sw}>
          <polygon points="10,70 10,25 30,42 50,8 70,42 90,25 90,70" />
        </SvgShape>
      );

    case 'checkmark':
      return (
        <SvgShape viewBox="0 0 100 100" fill={f} stroke={s} strokeWidth={sw}>
          <circle cx="50" cy="50" r="45" opacity="0.2" />
          <polyline points="28,50 44,66 74,36" fill="none" stroke={f} strokeWidth="10" strokeLinecap="round" strokeLinejoin="round" />
        </SvgShape>
      );

    case 'x-mark':
      return (
        <SvgShape viewBox="0 0 100 100" fill={f} stroke={s} strokeWidth={sw}>
          <circle cx="50" cy="50" r="45" opacity="0.2" />
          <line x1="33" y1="33" x2="67" y2="67" stroke={f} strokeWidth="10" strokeLinecap="round" />
          <line x1="67" y1="33" x2="33" y2="67" stroke={f} strokeWidth="10" strokeLinecap="round" />
        </SvgShape>
      );

    case 'music-note':
      return (
        <SvgShape viewBox="0 0 100 100" fill={f} stroke={s} strokeWidth={sw}>
          <path d="M70,10v55c0,10-9,18-20,18S30,75,30,65s9-15,20-15c4,0,7,1,10,3V25L40,30v-15L70,10z" />
        </SvgShape>
      );

    case 'swipe-up':
      return (
        <SvgShape viewBox="0 0 100 100" fill="none" stroke={f} strokeWidth={0}>
          <line x1="50" y1="85" x2="50" y2="30" stroke={f} strokeWidth="6" strokeLinecap="round" />
          <polyline points="30,50 50,25 70,50" fill="none" stroke={f} strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
          <circle cx="50" cy="15" r="6" fill={f} />
        </SvgShape>
      );

    case 'blob':
      return (
        <SvgShape viewBox="0 0 100 100" fill={f} stroke={s} strokeWidth={sw}>
          <path d="M45,10 C65,5 85,15 90,35 C95,55 85,75 70,85 C55,95 35,90 20,78 C5,66 5,45 15,30 C25,15 35,12 45,10Z" />
        </SvgShape>
      );

    case 'scalloped-circle':
      return (
        <SvgShape viewBox="0 0 100 100" fill={f} stroke={s} strokeWidth={sw}>
          <path d="M50,8 C55,15 62,10 67,15 C72,20 68,28 73,33 C78,38 87,36 90,43 C93,50 86,55 87,62 C88,69 96,74 95,81 C94,88 85,89 81,95 C77,95 72,90 65,91 C58,92 55,95 50,95 C45,95 42,92 35,91 C28,90 23,95 19,95 C15,89 6,88 5,81 C4,74 12,69 13,62 C14,55 7,50 10,43 C13,36 22,38 27,33 C32,28 28,20 33,15 C38,10 45,15 50,8Z" />
        </SvgShape>
      );

    case 'brace':
      return (
        <SvgShape viewBox="0 0 100 100" fill="none" stroke={f} strokeWidth={0}>
          <path d="M35,5 C25,5 20,15 20,25 L20,40 C20,45 15,50 10,50 C15,50 20,55 20,60 L20,75 C20,85 25,95 35,95 M65,5 C75,5 80,15 80,25 L80,40 C80,45 85,50 90,50 C85,50 80,55 80,60 L80,75 C80,85 75,95 65,95" fill="none" stroke={f} strokeWidth="6" strokeLinecap="round" />
        </SvgShape>
      );

    case 'snapchat':
      return (
        <SvgShape viewBox="0 0 100 100" fill={f} stroke={s} strokeWidth={sw}>
          <path d="M50,8c12,0,22,10,24,25c1,5,0,10,0,15c5,2,12,3,15,6c-5,3-12,4-14,8c-2,5,5,18-8,25c-8,4-12,3-17,5c-5-2-9-1-17-5c-13-7-6-20-8-25c-2-4-9-5-14-8c3-3,10-4,15-6c0-5-1-10,0-15C28,18,38,8,50,8z" />
        </SvgShape>
      );

    case 'spotify':
      return (
        <SvgShape viewBox="0 0 100 100" fill={f} stroke={s} strokeWidth={sw}>
          <circle cx="50" cy="50" r="45" />
          <path d="M30,38 C45,33 65,33 78,40" fill="none" stroke="#fff" strokeWidth="6" strokeLinecap="round" />
          <path d="M33,52 C45,48 62,48 73,53" fill="none" stroke="#fff" strokeWidth="5" strokeLinecap="round" />
          <path d="M37,65 C47,62 58,62 68,66" fill="none" stroke="#fff" strokeWidth="4" strokeLinecap="round" />
        </SvgShape>
      );

    case 'telegram':
      return (
        <SvgShape viewBox="0 0 100 100" fill={f} stroke={s} strokeWidth={sw}>
          <circle cx="50" cy="50" r="45" />
          <path d="M25,50 L72,32 L60,75 L47,58 L25,50Z" fill="#fff" />
          <path d="M47,58 L50,72 L55,58" fill="#d2e4f0" />
        </SvgShape>
      );

    case 'shopping-bag':
      return (
        <SvgShape viewBox="0 0 100 100" fill={f} stroke={s} strokeWidth={sw}>
          <rect x="18" y="35" width="64" height="55" rx="5" />
          <path d="M33,40 V25 C33,15 40,8 50,8 S67,15 67,25 V40" fill="none" stroke={f} strokeWidth="6" strokeLinecap="round" />
        </SvgShape>
      );

    case 'percent-badge':
      return (
        <SvgShape viewBox="0 0 100 100" fill={f} stroke={s} strokeWidth={sw}>
          <circle cx="50" cy="50" r="42" />
          <circle cx="38" cy="38" r="8" fill="none" stroke="#fff" strokeWidth="4" />
          <circle cx="62" cy="62" r="8" fill="none" stroke="#fff" strokeWidth="4" />
          <line x1="65" y1="33" x2="35" y2="67" stroke="#fff" strokeWidth="4" strokeLinecap="round" />
        </SvgShape>
      );

    case 'price-sticker':
      return (
        <SvgShape viewBox="0 0 100 100" fill={f} stroke={s} strokeWidth={sw}>
          <polygon points="50,5 58,20 75,12 70,30 90,32 78,45 92,58 75,60 78,78 60,70 52,88 42,72 25,80 28,62 8,58 22,45 10,32 28,30 25,12 42,20" />
          <text x="50" y="55" textAnchor="middle" fill="#fff" fontSize="22" fontWeight="bold">$</text>
        </SvgShape>
      );

    default: // rectangle
      return (
        <div style={{
          width: '100%', height: '100%',
          background: f,
          border: data.stroke ? `${sw}px solid ${s}` : 'none',
          borderRadius: `${data.borderRadius || 0}px`,
        }} />
      );
  }
}
